// Controls
import { Icon, Image, ImageFit, css, useTheme } from "@fluentui/react";
// Styles
import { getGroupColorClassName } from "../../../common/GroupsColors.styles";
import { getClassNames, getStyles } from "./DynamicIcon.styles";
// Utilities
import { parseInitialsFromName } from "@ms/uno-utilities/lib/local/StringUtilities";
import React from "react";
import { parseIconTileClassname } from "../../../utilities/ColorUtilities";
/**
 * Dynamic icon allows for a state based icon or photo, or falls back to initials based on name.
 */ export const DynamicIcon = (props)=>{
    const { stateBasedIcons, focused, name, styles, size = 24, iconSvgSize = 20 } = props; // Default size is 24, if not provided.
    const theme = useTheme();
    const dynamicIconStyles = getStyles(theme, size, iconSvgSize, styles);
    const { initialsWrapper, initialsText } = getClassNames(dynamicIconStyles);
    const { image, icon } = dynamicIconStyles.subComponentStyles;
    // If no icon or URL for image is provided, use the name of the plan to render the icon
    if (stateBasedIcons == null) {
        if (name != null) {
            const initials = parseInitialsFromName(name);
            const groupColor = getGroupColorClassName(parseIconTileClassname(name));
            return /*#__PURE__*/ React.createElement("div", {
                className: css(initialsWrapper, groupColor)
            }, /*#__PURE__*/ React.createElement("span", {
                className: initialsText
            }, initials));
        } else {
            return null;
        }
    }
    // If URL for image is provided, use it to render the icon
    if (typeof stateBasedIcons === "string") {
        return /*#__PURE__*/ React.createElement(Image, {
            styles: image,
            imageFit: ImageFit.cover,
            src: stateBasedIcons,
            alt: ""
        });
    } else {
        const iconProps = stateBasedIcons;
        if (focused && iconProps.focusedIcon != null) {
            return /*#__PURE__*/ React.createElement(Icon, {
                styles: icon,
                ...iconProps.focusedIcon
            });
        } else {
            return /*#__PURE__*/ React.createElement(Icon, {
                styles: icon,
                ...iconProps.normalIcon
            });
        }
    }
};
